export default "__VITE_ASSET__DE5_VHOg__"